import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TourService } from './logic/tour.service';
import { TourLogicService } from './logic/tour/tour-logic.service';
import { TourDaoService } from './dao/tour-dao.service';
import { TourDbDaoService } from './dao/tour-dao/tour-db-dao.service';
import { TourDbTableDefinition } from './dao/tour-dao/tour-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: TourService, useClass: TourLogicService },
    { provide: TourDaoService, useClass: TourDbDaoService },
    { provide: TourDbTableDefinition },
  ]
})
export class TourModule {}
